import Navbar from "./navbar";
import Footer from "./footer";
import { Outlet } from "react-router-dom";
import TopBanner from "./topbanner";
import LatestNewsTicker from "./latestnewswidget";

function Layout() {
  return (
    <>
    <TopBanner/>
    <LatestNewsTicker/>
      <Navbar />
      <main className="min-h-screen">
        <Outlet />
      </main>
       <Footer />
    </>
  );
}

export default Layout;
